// extracted by mini-css-extract-plugin
module.exports = {"strip":"PartnersCalendar_strip__phy2C"};